export default "__VITE_ASSET__Ki7jrils__"